module.exports = __webpack_public_path__ + "static/media/emrald_Diamond.a1441c38.jpg";